import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { SVGAccidentalSplit } from '../../Util/Music/Accidentals/Accidentals';
import { Music } from '../../Util/Music/Music';
import { TransformTranslate } from '../../Util/Transform/Transform';
import './FretBoard.scss'
import { ClassNames } from '../../Util/ClassNames';
import { NotesSelect } from '../NoteButtons/NotesSelect';
import { Menu, MenuItem, MenuRadioGroup, RadioChangeEvent } from '@szhsin/react-menu';
import { Modes } from '../../Util/Music/Modes';
import { Note } from '../../Data/HexMap/Note';
import { Coordinates } from '../../Util/Math/Coordinates';
import { NoteCtrlMenuState } from '../CtrlMenus/NoteCtrlMenuState';
import { useNoteCtrlMenuStore } from '../CtrlMenus/NoteCtrlMenuStore';
import { FretBoardNoteCtrlMenu } from '../CtrlMenus/FretBoardNoteCtrlMenu';
import { FretBoardNoteCtrlMenuState } from '../CtrlMenus/FretBoardNoteCtrlMenuState';
import { useFretBoardNoteCtrlMenuStore } from '../CtrlMenus/FretBoardNoteCtrlMenuStore';
import { MenuArrow } from '../Menu/MenuDownArrow';
import Draggable from 'react-draggable';
export interface StringConfig{
    tonic:number
    index:number
    octave:number
    y:number
}
export interface Line{
    start:Coordinates
    end:Coordinates
}
export class FretBoardNote{
    noteIndex:number
    stringIndex:number
    fretIndex:number
    tonic:number
    visible:boolean = false
    ghosted:boolean = false
    isRoot:boolean = false
    selected:boolean = false
    altLabel:string = ''
    x:number = 0
    y:number = 0
    color:string|null = null
    constructor(noteIndex:number, stringIndex:number, fretIndex:number, tonic:number){
        this.noteIndex = noteIndex
        this.stringIndex = stringIndex
        this.fretIndex = fretIndex
        this.tonic = tonic

    }
}
export function FretBoardV2(){
    const neckWidth:number = 1200
    const neckHeight:number = 350;
    const fretCount:number = 16
    const fretSpacing:number = neckWidth/(fretCount + 1)
    const nutOffset:number = fretSpacing
    const fretWidth:number = 6
    const stringEdge:number = 20
    const stringSpan:number = neckHeight - (stringEdge * 2)
    const stringSpacing:number = stringSpan/5
    const stringWidth:number = 1
    const stringSetSix:number = 0
    const stringSetFour:number = 2
    const [stringSetStart, setStringSetStart] = useState(stringSetSix)
    const getStringY = (index:number) => {
        return( (index * stringSpacing) + stringEdge )
    }
    const stringConfigs:StringConfig[] = [
        {tonic:Music.E, index:0, octave:0, y:getStringY(0)},
        {tonic:Music.B, index:1, octave:0, y:getStringY(1)},
        {tonic:Music.G, index:2, octave:0, y:getStringY(2)},
        {tonic:Music.D, index:3, octave:0, y:getStringY(3)},
        {tonic:Music.A, index:4, octave:0, y:getStringY(4)},
        {tonic:Music.E, index:5, octave:1, y:getStringY(5)}
    ]
    const buildNotes = () => {
        const notes:FretBoardNote[] = []
        stringConfigs.forEach((stringConfig:StringConfig, stringIndex:number)=>{
            if(stringIndex < stringSetStart){
                console.log('under the limit')
                return 
            }
            for(let fretIndex:number = 0; fretIndex < fretCount + 1; fretIndex++){
                const tonic:number = ((stringConfig.tonic + fretIndex) % 12)
                const noteIndex:number = notes.length
                notes.push(new FretBoardNote(noteIndex, stringIndex, fretIndex, tonic))
        }})
        return notes
    }
    const [tonic, setTonic] = useState<number>(Music.C)
    const [notes, setNotes] = useState<FretBoardNote[]>(buildNotes())
    const [lines, setLines] = useState<Line[]>([])
    const [showPositionLabels, setShowPositionLabels] = useState<boolean>(false)
    const [showChordTones, setShowChordTones] = useState<boolean>(false)
    const refreshNotes = () => {
        setNotes(notes.concat())
    }
    const FretBoardNoteComp = (props:{note:FretBoardNote}) => {
        const radius:number = stringSpacing * .25
        const x:number = ((props.note.fretIndex * fretSpacing) + nutOffset) - (radius)
        const y:number = stringConfigs[props.note.stringIndex].y
        props.note.x = x
        props.note.y = y
        const fontSize:number = radius * 1.3
        const keyNotes:number[] = Music.getKeyScale(tonic)
        const position:number = keyNotes.indexOf(props.note.tonic)
        const PositionLabel = () => {
            let label:string = ''
            if(position !== -1){
                label = String(position + 1)
            }
            return(
                <g className={'note-label position'}>
                    <text dy='0.2em' style={{fontSize:fontSize}}>{label}</text>
                </g>
            )
        }
        const TonicLabel = () => {
            return(
                <g className={'note-label'}>
                    <SVGAccidentalSplit baseFontSize={fontSize} tonic={props.note.tonic}/>
                </g>
            )
        }
        const NoteLabel = () => {
            return( (showPositionLabels) ? <PositionLabel/> : <TonicLabel/> )
        }
         const getClassNames = () =>{
            const classNames:ClassNames = new ClassNames(['note-container'])
            if(props.note.visible){
                classNames.addClass('visible')
            }            
            if(props.note.selected){
                classNames.addClass('selected')
            }            
            if(props.note.color){
                classNames.addClass(props.note.color)
            }
            if(props.note.isRoot){
                classNames.addClass('root')
            }
            if(props.note.ghosted){
                classNames.addClass('ghosted')
            }
            if(showChordTones){
                classNames.addClass('position-' + String(position + 1))     
            }
            return classNames.toString()
        }
        const fretNoteConfigSetter:Function = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>state.setNoteConfig)
        const onCtrl = (e:React.MouseEvent, note:FretBoardNote) => {
                const selectedNotes:FretBoardNote[] = notes.filter((note:FretBoardNote)=>{
                    return note.selected
                })
                console.log('selectedNotes.length', selectedNotes.length)
                fretNoteConfigSetter(note, new Coordinates(e.clientX, e.clientY), refreshNotes, selectedNotes, drawLines)
                //props.onNoteClick(props.note, e, true)
        }
        const onFretNoteClick = (e:React.MouseEvent, note:FretBoardNote) => {
            e.preventDefault()
            e.stopPropagation()
            if(e.metaKey && note){
                note.selected = !note.selected
                refreshNotes()
                return
            }
            if(!note.visible){
                note.visible = true
                refreshNotes()
                return
            }
            onCtrl(e, note)
        }
        return(
            <g onClick={(e)=>{onFretNoteClick(e, props.note)}} onContextMenu={(e)=>{onCtrl(e, props.note)}} className={getClassNames()} transform={TransformTranslate(x, y)}>
                <circle className={'fret-note-circle'} r={radius} cx={0} cy={0}/>
                <NoteLabel/>
            </g>
        )
    }
    const NoteComps = () => {
        return(
            <g className={'fretboard-note-comps'}>
                {notes.map((note:FretBoardNote, index:number) => {
                    return(<FretBoardNoteComp key={index} note={note}></FretBoardNoteComp>)
                })}
            </g>
        )
    }
    const Frets = () => {
        const frets:JSX.Element[] = []
        for(let i:number = 0; i < fretCount; i++){
            const w:number = (i === 0) ? fretWidth * 1.8 : fretWidth
            const getClassNames = () => {
                const classNames:ClassNames = new ClassNames(['fret'])
                if(i === 0){
                    classNames.addClass('nut')
                }
                return classNames.toString()
            }
            frets.push(
                <g key={i} transform={TransformTranslate((i * fretSpacing) + nutOffset, 0)}>
                    <rect className={getClassNames()} width={w} height={neckHeight}></rect>
                </g>
            )
        }
        return <g className={'frets'}>{frets}</g>
    }
    const Strings = () => {
        const strings:JSX.Element[] = []
        stringConfigs.forEach((config:StringConfig, index:number)=>{
            strings.push(
                <g key={index} transform={TransformTranslate(0, config.y)}>
                    <rect className={'string'} width={neckWidth} height={stringWidth + (index * .5)}></rect>
                </g>
            )
        })
        return <g className={'strings'}>{strings}</g>
    }
    const Dots = () => {
        return(
            <g> className={'dots'}
                <g transform={TransformTranslate((fretSpacing * 3.5), neckHeight/2)}>
                    <circle className={'neck-dot'} r={fretSpacing * .3} cx={0} cy={0}/>
                </g>
                <g transform={TransformTranslate((fretSpacing * 5.5), neckHeight/2)}>
                    <circle className={'neck-dot'} r={fretSpacing * .3} cx={0} cy={0}/>
                </g>
                <g transform={TransformTranslate((fretSpacing * 7.5), neckHeight/2)}>
                    <circle className={'neck-dot'} r={fretSpacing * .3} cx={0} cy={0}/>
                </g>
                <g transform={TransformTranslate((fretSpacing * 9.5), neckHeight/2)}>
                    <circle className={'neck-dot'} r={fretSpacing * .3} cx={0} cy={0}/>
                </g>
                <g transform={TransformTranslate((fretSpacing * 12.5), (neckHeight/2) - stringSpacing)}>
                    <circle className={'neck-dot'} r={fretSpacing * .3} cx={0} cy={0}/>
                </g>
                <g transform={TransformTranslate((fretSpacing * 12.5), (neckHeight/2) + stringSpacing)}>
                    <circle className={'neck-dot'} r={fretSpacing * .3} cx={0} cy={0}/>
                </g>
            </g>
        )
    }
    const deselectAllNotes = () => {
        notes.forEach((note:FretBoardNote)=>{
            note.selected = false;
            refreshNotes()
        })        
    }
    const clearAll = () => {
        notes.forEach((note:FretBoardNote)=>{
            note.visible = false; 
            note.isRoot = false;
            note.ghosted = false;
            note.selected = false;
            note.color = null;
            refreshNotes()
        })
        setScaleType('')
    }
    const isGhosted:MutableRefObject<boolean> = useRef(false)
    const toggleGhosting = () => {
        isGhosted.current = !isGhosted.current
        notes.forEach((note:FretBoardNote)=>{
            note.ghosted = isGhosted.current
        })
        refreshNotes()
    }
    const toggleChordTones = () => {
        setShowChordTones(!showChordTones)
    }
    const onTonicChange = (tonic:number) => {
        setLines([])
        setTonic(tonic)
        showNotesOfScale(scaleType)
    }
    const scaleNames:string[] = Modes.AltNames.concat(['Major Pentatonic', 'Minor Pentatonic', 'Major Blues', 'Minor Blues'])
    const [scaleType, setScaleType] = useState<string>('')
    const showNotesOfScale = (scaleType:string, updatedNotes?:FretBoardNote[]) => {
        if(scaleType === ''){ return }
        const getScale = () => {
            const i:number = Modes.AltNames.indexOf(scaleType)
            if(i > -1){
                return Modes.getParallelModeScale(tonic, i)
            }
            if(scaleType === 'Major Pentatonic') return Music.getPentatonicScale(tonic)
            if(scaleType === 'Minor Pentatonic') return Music.getPentatonicMode((tonic + 3) % 12,4)
            if(scaleType === 'Major Blues') return Music.getBluesScale(tonic)
            if(scaleType === 'Minor Blues') return Music.getMinorBluesScale(tonic, 5)
            return []
        }
        const scaleTonics:number[] = getScale()
        const freshNotes:FretBoardNote[] = (updatedNotes) ? updatedNotes : notes.concat()
        freshNotes.forEach((note:FretBoardNote)=>{
            if(note.stringIndex < stringSetStart){return}
            if(!note.visible) note.ghosted = false
            note.visible = (scaleTonics.includes(note.tonic))
            note.isRoot = (scaleTonics[0] === note.tonic)
        })
        setNotes(freshNotes)
        
    }
    const onScaleMenuChange = (e:RadioChangeEvent) => {
        setLines([])
        setScaleType(e.value)
        showNotesOfScale(e.value)
    }
    const onLabelChange = (e:RadioChangeEvent) => {
        setShowPositionLabels(e.value)
    }
    useEffect(()=>{showNotesOfScale(scaleType)}, [tonic])
    const Lines = () => {
        return(<g>{
                    lines.map((line:Line, index:number)=>{
                        return <line key={index} className={'note-line'} x1={line.start.x} y1={line.start.y} x2={line.end.x} y2={line.end.y}></line>
                    })
                }</g>
        )
    }
    const drawPentatonicLines = () => {
        let freshLines:Line[] = []
        const columns:FretBoardNote[][] = []
        const allStringNotes:FretBoardNote[][] = []
        for(let i = stringSetStart; i < 6; i++){
            const stringNotes:FretBoardNote[] = notes.filter((note:FretBoardNote)=>{
                return note.stringIndex === i && note.visible
            })
            allStringNotes.push(stringNotes)
        }
        for(let position = 0; position < 6; position++){
            const column:FretBoardNote[] = []
            allStringNotes.forEach((stringNotes:FretBoardNote[])=>{
                column.push(stringNotes[position])
            })
            columns.push(column)
        }
        columns.forEach((column:FretBoardNote[], index:number)=>{
            column.forEach((note:FretBoardNote)=>{
                note.selected = true
            })
            freshLines = freshLines.concat(getLines())
            column.forEach((note:FretBoardNote)=>{note.selected = false})
        })
        setLines(freshLines)
    }
    const getLines = () => {
        const selectedNotes:FretBoardNote[] = notes.filter(
            (note:FretBoardNote)=>{
                return note.selected === true
            }
        )
        const freshLines:Line[] = []
        if(selectedNotes.length > 1){
            selectedNotes.forEach((note:FretBoardNote, index:number)=>{
                const nextNote:FretBoardNote = selectedNotes[index + 1]
                if(nextNote){
                    const line:Line = {
                        start:new Coordinates(note.x, note.y), 
                        end: new Coordinates(nextNote.x, nextNote.y)}
                    freshLines.push(line)
                }
            })
        }
        return freshLines
    }
    const drawLines = () => {
        const freshLines:Line[] = getLines()
        setLines(lines.concat(freshLines))
        notes.forEach((note:FretBoardNote)=>{note.selected = false})
        refreshNotes()
    }
    const clearLines = () => {
        setLines([])
        notes.forEach((note:FretBoardNote)=>{note.selected = false})
        refreshNotes()
    }
    const clearColors = () => {
        notes.forEach((note:FretBoardNote)=>{note.color = null})
        refreshNotes()
    }
    useEffect(()=>{showNotesOfScale(scaleType, buildNotes())}, [stringSetStart])
    return(
        <div className={'fretboard'}>

            <div style={{width:700, margin:'auto', marginTop:40, marginBottom:40}}>
                <NotesSelect tonic={tonic} onChange={onTonicChange}/>
                <Menu menuButton={<button type='button'>Scale : {scaleType} <MenuArrow/></button>}>
                    <MenuRadioGroup onRadioChange={onScaleMenuChange} value={scaleType}>
                        {scaleNames.map((scaleName:string, index:number)=>{
                            return <MenuItem key={scaleName} type="radio" value={scaleName}>{scaleName}</MenuItem>
                        })}
                    </MenuRadioGroup>
                </Menu>
                <Menu menuButton={<button type='button'>Labels : {(showPositionLabels) ? 'Numbers' : 'Notes'} <MenuArrow/></button>}>
                    <MenuRadioGroup onRadioChange={onLabelChange} value={showPositionLabels}>
                        <MenuItem key={'notes'} type="radio" value={false}>Notes</MenuItem>
                        <MenuItem key={'numbers'} type="radio" value={true}>Numbers</MenuItem>
                    </MenuRadioGroup>
                </Menu>
            </div>
            <svg onClick={deselectAllNotes} width={1200} height={neckHeight + 50}>
                <rect className={'fretboard-neck'} width={neckWidth} height={neckHeight}></rect>
                <Dots/>
                <Frets/>
                <Strings/>
                <Lines/>
                <NoteComps/>
            </svg>
            <div>
                <Menu menuButton={<button type='button'>All Notes <MenuArrow/></button>}>
                        <MenuItem onClick={clearAll}>Clear All</MenuItem>
                        <MenuItem onClick={toggleGhosting}>Toggle Ghosting</MenuItem>
                        <MenuItem onClick={toggleChordTones}>Toggle Chord Tones</MenuItem>
                        <MenuItem onClick={clearColors}>Clear Colors</MenuItem>
                        <MenuItem onClick={clearLines}>Clear Lines</MenuItem>
                        <MenuItem onClick={deselectAllNotes}>Deselect</MenuItem>
                </Menu>
                {scaleType.includes('Pentatonic') && <button onClick={drawPentatonicLines} type={'button'}>Draw Pentatonic Lines</button>}
            </div>
            <FretBoardNoteCtrlMenu/>
        </div>
    )
}
